'use client'

import { useState } from 'react'

import { tw } from '@/lib/utils'

interface AlertReadMoreProps {
  readMoreLabel: string
  readLessLabel: string
  children: React.ReactNode
}

export const AlertReadMore = ({ readMoreLabel, readLessLabel, children }: AlertReadMoreProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div>
      <div className={tw(!expanded && 'line-clamp-2')}>{children}</div>
      <button
        type="button"
        data-tracking="ignore"
        aria-expanded={expanded}
        data-ht-disclosure-trigger="read-more"
        className="text-navy/50 hover:text-navy mt-1.5 cursor-pointer text-sm font-medium"
        onClick={() => setExpanded((v) => !v)}
      >
        {expanded ? readLessLabel : readMoreLabel}
      </button>
    </div>
  )
}
